import { withAuthenticationRequired } from '@auth0/auth0-react';
import React from 'react';

export const ProtectedRoute = ({ component, ...args }: React.PropsWithChildren<any>) => {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
};
